<template>
  <v-avatar
    :size="size"
    :color="this.color || 'transparent'"
    :class="
      'white--text ' +
        (cssClass || '') +
        (borderColor ? ' ' + borderColor + '-border' : '')
    "
  >
    <img v-if="avatarUrl" :src="avatarUrl" :alt="name" />
    <v-icon v-else-if="icon" :color="borderColor || 'white'" x-large>{{
      icon
    }}</v-icon>
    <template v-else>{{ (this.name || " ")[0].toUpperCase() }}</template>
  </v-avatar>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    color: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    cssClass: {
      type: String,
      default: ""
    },
    avatarUrl: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 20
    },
    borderColor: {
      type: String,
      default: ""
    },
    icon: { type: String, default: "" }
  }
};
</script>

<style lang="scss" scoped>
.v-avatar {
  &.white-border {
    border: 2px solid #fff !important;
  }

  &.secondarytext-border {
    border: 2px solid var(--v-secondarytext-base) !important;
  }
}
</style>
